import React from 'react'

const { PUBLIC_URL } = process.env

const HomeRunProfitabilityBanner = ({ activeAccordion }) => {
  return (
    <div className="dealmed-home-run__banner-wrapper">
      <img
        src={
          activeAccordion?.accordionImage?.fields?.file?.url ??
          `${PUBLIC_URL}/images/homepage-drawing-person.png`
        }
        className="dealmed-home-run__image"
        alt=""
        loading="lazy"
      />
    </div>
  )
}

export default HomeRunProfitabilityBanner
